export const SERVICE_CATEGORIES = [
    {
        name: "Interior House Painting",
        short: "Interior Painting",
        desc: "Complete interior repaints with premium, low-odour paints — walls, ceilings and woodwork prepped properly and finished sharp.",
        bullets: ["Colour consultation", "Furniture & floor protection", "Two-coat premium finish"],
        icon: "Paintbrush",
    },
    {
        name: "Exterior House Painting",
        short: "Exterior Painting",
        desc: "Weather-grade exterior painting: pressure washing, scraping, sanding, priming and coatings built for Ontario seasons.",
        bullets: ["Pressure wash & mildew treatment", "Wood rot & crack repair", "Weather-grade coatings"],
        icon: "Building2",
    },
    {
        name: "Bedroom, Bathroom, Kitchen & Living Room Painting",
        short: "Room Painting",
        desc: "Room-by-room repainting with the right products for each space — washable finishes in kitchens and baths, ceilings included.",
        bullets: ["Kitchen & bath-grade paints", "Cabinet & door painting", "Accent wall work"],
        icon: "Lamp",
    },
    {
        name: "Ceiling & Wall Painting",
        short: "Ceilings & Walls",
        desc: "Flat, even ceiling coats and flawless wall finishes — including stipple repair and texture matching.",
        bullets: ["Stipple & texture repair", "Crack & seam fixing", "Dust-controlled work zones"],
        icon: "Layers",
    },
    {
        name: "Baseboards, Trim, Doors & Moulding Painting",
        short: "Trim & Moulding",
        desc: "Sharp, durable finishes for trim, baseboards, doors and architectural moulding — hand-sanded and sprayed or brushed to spec.",
        bullets: ["Spray-finish options", "Caulk & gap filling", "Enamel & lacquer finishes"],
        icon: "Ruler",
    },
    {
        name: "Drywall Repairs & Surface Preparation",
        short: "Drywall & Prep",
        desc: "Patching, taping, sanding and priming — the unglamorous work that makes the paint job last.",
        bullets: ["Patch & hole repair", "Tape & finish", "Stain-blocking primers"],
        icon: "Hammer",
    },
    {
        name: "New Construction & Custom Home Painting",
        short: "New Construction",
        desc: "Builder-grade and custom-home painting on your schedule — coordinated around other trades, punch-list ready.",
        bullets: ["Builder schedules respected", "Spray & back-rolling", "Model home finishes"],
        icon: "Home",
    },
    {
        name: "Residential Renovations & Repainting",
        short: "Renovations",
        desc: "Full refreshes alongside renovations — walls, ceilings, trim and doors renewed in one coordinated scope.",
        bullets: ["Coordinated with your renovation", "Colour changes managed", "Detailed punch lists"],
        icon: "Sparkles",
    },
    {
        name: "Commercial Painting",
        short: "Commercial",
        desc: "Offices, retail, restaurants and industrial units — durable coatings, after-hours crews and safe, tidy sites.",
        bullets: ["After-hours scheduling", "High-traffic coatings", "Minimal business disruption"],
        icon: "Building",
    },
    {
        name: "Multi-Unit Residential & Property Management",
        short: "Multi-Unit & Property Mgmt",
        desc: "Turnovers, hallways and common areas across portfolios — consistent standards unit after unit, on rotating schedules.",
        bullets: ["Unit turnover programs", "Common area repaints", "Consistent scope & pricing"],
        icon: "KeyRound",
    },
    {
        name: "General Contractor & Builder Contracts",
        short: "GC & Builder Contracts",
        desc: "Subcontract painting packages for GCs and builders — itemized quotes, dependable crews and job-site discipline.",
        bullets: ["Itemized subcontract quotes", "Drawings-based takeoffs", "Scheduled around your trades"],
        icon: "HardHat",
    },
];

export const PROPERTY_TYPES = ["Residential", "Commercial", "Multi-Family", "New Construction"];

export const LEAD_STATUSES = ["new", "contacted", "estimate_requested", "quoted", "won", "lost"];

export const STATUS_LABELS = {
    new: "New",
    contacted: "Contacted",
    estimate_requested: "Estimate Requested",
    quoted: "Quoted",
    won: "Won",
    lost: "Lost",
};

export const REGIONS = ["Toronto", "Mississauga", "Oakville", "Vaughan", "Markham", "Burlington", "Richmond Hill", "Brampton", "Etobicoke", "Scarborough", "North York"];

export default SERVICE_CATEGORIES;